import { commonjsGlobal as l } from "./index135.mjs";
import { __module as i } from "./index166.mjs";
i.exports;
(function(u) {
  (function(p, o, m) {
    function f(r) {
      var n = this, s = x();
      n.next = function() {
        var e = 2091639 * n.s0 + n.c * 23283064365386963e-26;
        return n.s0 = n.s1, n.s1 = n.s2, n.s2 = e - (n.c = e | 0);
      }, n.c = 1, n.s0 = s(" "), n.s1 = s(" "), n.s2 = s(" "), n.s0 -= s(r), n.s0 < 0 && (n.s0 += 1), n.s1 -= s(r), n.s1 < 0 && (n.s1 += 1), n.s2 -= s(r), n.s2 < 0 && (n.s2 += 1), s = null;
    }
    function c(r, n) {
      return n.c = r.c, n.s0 = r.s0, n.s1 = r.s1, n.s2 = r.s2, n;
    }
    function a(r, n) {
      var s = new f(r), e = n && n.state, t = s.next;
      return t.int32 = function() {
        return s.next() * 4294967296 | 0;
      }, t.double = function() {
        return t() + (t() * 2097152 | 0) * 11102230246251565e-32;
      }, t.quick = t, e && (typeof e == "object" && c(e, s), t.state = function() {
        return c(s, {});
      }), t;
    }
    function x() {
      var r = 4022871197, n = function(s) {
        s = String(s);
        for (var e = 0; e < s.length; e++) {
          r += s.charCodeAt(e);
          var t = 0.02519603282416938 * r;
          r = t >>> 0, t -= r, t *= r, r = t >>> 0, t -= r, r += t * 4294967296;
        }
        return (r >>> 0) * 23283064365386963e-26;
      };
      return n;
    }
    o && o.exports ? o.exports = a : this.alea = a;
  })(
    l,
    u
  );
})(i);
var b = i.exports;
export {
  b as a
};
